// Prefer persisted final result IDs. Legacy records use stable internal IDs
// or a complete analysis/timepoint signature before positional review IDs.
const stable = value => Array.isArray(value) ? value.map(stable)
  : value && typeof value === 'object' ? Object.fromEntries(Object.keys(value).sort().map(key => [key, stable(value[key])])) : value;
const fields = ['source', 'target', 'source_file', 'evidence_id', 'predicate', 'assertion', 'source_role', 'target_role', 'direction', 'method', 'model_context', 'statistics', 'source_timepoint', 'target_timepoint', 'source_timepoints', 'target_timepoints', 'model_id', 'subgroup', 'contrast', 'reference_group', 'analysis_type'];
export function edgeReviewIndex(provenance) {
  const names = new Map();
  (provenance?.entities || []).forEach(entity => {
    for (const key of [entity.entity_id, entity.graph_title, entity.name]) if (key) names.set(key, entity.name);
  });
  const key = record => JSON.stringify(stable(Object.fromEntries(fields.map(field => [field,
    ['source', 'target'].includes(field) ? names.get(record[field]) || record[field] : record[field] ?? null,
  ]))));
  const index = new Map();
  const direct = new Map();
  (provenance?.relationships || []).forEach((record, i) => {
    const signature = key(record);
    const ids = index.get(signature) || [];
    const id = record.result_id || `R${String(i + 1).padStart(5, '0')}`;
    ids.push(id);
    for (const identifier of [record.record_id, record.relation_id].filter(Boolean)) {
      const existing = direct.get(identifier) || [];
      direct.set(identifier, [...new Set([...existing, id])]);
    }
    index.set(signature, ids);
  });
  return record => record.result_id ? [record.result_id]
    : direct.get(record.record_id) || direct.get(record.relation_id) || index.get(key(record)) || [];
}
